<template>
  <div
    class="sorter-item"
  >
    <div
      v-if="draggingOverTop"
      class="_drag-over-top"
    />
    <m-btn
      class="_handle"
      :disabled="sortDisabled"
      icon="drag"
      hide-border
      fab
      light
    />
    <m-select
      v-model:value="selectedSortOption"
      :items="availableSortOptions"
      :read-only="disabled"
      class="_block _option"
    />
    <m-select
      v-model:value="selectedSortOrder"
      :items="sortOrderOptions"
      :read-only="disabled"
      class="_block _order"
    />
    <div
      v-if="!disabled"
      class="_block _delete"
    >
      <m-btn
        icon="close"
        fab
        light
        hide-border
        small
        @click="$emit('delete')"
      />
    </div>
    <div
      v-if="draggingOverBottom"
      class="_drag-over-bottom"
    />
  </div>
</template>

<script>
import useSorterOptions from '@/composables/sort/sorter-options';
import { orderEntitiesEqual } from '@/lib/sort';

export default {
  name: 'SorterItem',
  props: {
    order: {
      type: Object,
      required: true,
    },
    orders: {
      type: Array,
      required: true,
    },
    sortOptions: {
      type: Array,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    draggingOverTop: {
      type: Boolean,
      default: false,
    },
    draggingOverBottom: {
      type: Boolean,
      default: false,
    },
    sortDisabled: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const { optionIcon, optionLabel } = useSorterOptions();
    return { optionIcon, optionLabel };
  },
  emits: ['delete', 'change'],
  data() {
    return {
      selectedSortOption: this.order,
      selectedSortOrder: this.order.desc,
    };
  },
  computed: {
    availableSortOptions() {
      const res = [this.selectedSortOption];

      for (let i = 0; i < this.sortOptions.length; i++) {
        if (typeof this.orders.find((fromOrders) => orderEntitiesEqual(fromOrders, this.sortOptions[i])) !== 'undefined') {
          continue;
        }

        res.push(this.sortOptions[i]);
      }

      return res.map((e) => ({
        text: this.optionLabel(e),
        value: e,
        icon: this.optionIcon(e),
      }));
    },
    sortOrderOptions() {
      return [
        {
          text: this.$t('sortOrder.descending'),
          value: true,
        },
        {
          text: this.$t('sortOrder.ascending'),
          value: false,
        },
      ];
    },
  },
  watch: {
    selectedSortOption(val) {
      this.$emit('change', {
        attr: val.attr,
        desc: true,
        langs: val.langs,
      });
    },
    selectedSortOrder(val) {
      this.$emit('change', {
        attr: this.selectedSortOption.attr,
        desc: val,
        langs: this.selectedSortOption.langs,
      });
    },
    order: {
      handler(val) {
        if (this.selectedSortOption.attr !== val.attr) {
          this.selectedSortOption.attr = val.attr;
        }
        if (this.selectedSortOption.langs !== val.langs) {
          this.selectedSortOption.langs = val.langs;
        }
        if (this.selectedSortOption.title !== val.title) {
          this.selectedSortOption.title = val.title;
        }
        if (this.selectedSortOrder !== val.desc) {
          if (typeof val.desc === 'undefined') {
            this.selectedSortOrder = true;
            return;
          }

          this.selectedSortOrder = val.desc;
        }
      },
    },
  },
};
</script>

<style scoped lang="scss" type="text/scss">
  .sorter-item {
    display: flex;
    align-items: center;
    position: relative;
    gap: .4rem;

    ._handle {
      width: 2rem;
      cursor: grab;
      flex: 0;
    }

    ._block {
      flex: 0;

      &._option {
        flex: 1;
      }

      &._order {
        flex: 0 0 12rem;
      }
    }

    ._drag-over-top {
      position: absolute;
      top: -6px;
      right: 0;
      left: 0;
      z-index: 88;
      width: 100%;
      height: 4px;
      pointer-events: none;
      background: $highlighted-color-dark;
      opacity: 1;
    }

    ._drag-over-bottom {
      position: absolute;
      right: 0;
      bottom: -6px;
      left: 0;
      z-index: 88;
      width: 100%;
      height: 4px;
      pointer-events: none;
      background: $highlighted-color-dark;
      opacity: 1;
    }
  }
</style>
